import { Component } from 'preact'
import WidgetV2Preview from '../components/widget-v2-preview';
import { LinkFilter, ThemeFilter } from '../components/filters';
import { __ } from '../../locales'

class V2AverageCategoryRating extends Component {
  render(props, state) {
    return (
      <WidgetV2Preview
        {...props}
        title={__('widget.trust_score_breakdown_banner.name')}
        description={__('widget.trust_score_breakdown_banner.description')}
        bestFor={[__('global.treatment_and_fees_section')]}
        widgetName={'average-category-rating-widget'}
        extraParams={[
          'slugs',
        ]}
        badgeTitle={__('widget.type.banner')}
        badgeColor={'#FFC1BE'}
      >
        <div className={'filters-wrapper mt-5 mb-5'}>
          <ThemeFilter {...props} />
          <LinkFilter
              {...props}
              hidden={props.inputs?.profileType === 'specialist' && props.selectedProfiles?.length <= 1}
          />
        </div>
      </WidgetV2Preview>
    );
  }
}

export default V2AverageCategoryRating
